<template>
    <div>
        <template>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(route, path) in routes.definitions" button v-bind:key="path" @click="edit(path, route)"> {{ path }}  </b-list-group-item>
            </b-list-group>
            <br />
            <b-button variant="primary" @click="create">{{ $t('create') }}</b-button>
        </template>

        <main-dialog size="lg" title="Path" v-model="editModal.show">
                <InputField type="text" name="path" :label="this.$t('path')" v-model.number="editModal.data.path" @error="fieldError"
                    :rules="{required: true, length: {min: 2, max: 64}}"
                    :disabled="!editModal.create"
                />

                <CodeEditor
                    v-model="editModal.data.code"
                    editor_description="When ever this route receive request pre-coded expression will be evaluted."
                    :label="this.$t('expression')"
                    :label-cols="2"
                    :horizontal="true"
                    :libs="libs"
                    :vars="vars"
                />

            <template v-slot:modal-footer>
                <b-button variant="danger" @click="remove" v-if="!editModal.create">{{ $t('remove') }}</b-button>
                <b-button variant="success" @click="save">{{ $t('save') }}</b-button>
            </template>
        </main-dialog>
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        InputField,
        CodeEditor
    },
    props: {
       value: {
         type: Object
       }
    },
    watch: {
        "editModal.data.path": function(nVal, oVal) {
            this.editModal.data.path = nVal.toLowerCase();
        }
    },
    computed: {
        vars() {
            return [
                {
                    name: "request",
                    usage: `{
                        "headers":{
                            "header":"string"
                        },
                        "body":{
                            // body sent through request
                        }
                    }`
                },
                {
                    name: "response",
                    usage: `{
                        // response status code
                        "status": 200,
                        "body":{
                            // response body
                        }
                    }  // mutating this object variables will be reflected on response`
                },
                {
                    name: "model",
                    usage: this.modelFields()
                },
            ]
        }
    },
    methods: {
        create() {
            this.editModal.show = true;
            this.editModal.create = true;

            this.editModal.data = {
                path: '',
                code: '',
            };
        },

        remove() {
            let defs = this.routes.definitions
            delete defs[this.editModal.data.path]

            this.routes.definitions = defs

            this.editModal.show = false;

            this.$emit('input', this.routes);
        },

        save() {
            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('invalidFields'));
                return;
            }

            if (this.routes.definitions === null) {
                this.routes.definitions = {};
            }

            let paths = Object.keys(this.routes.definitions)
            if (paths.indexOf(this.editModal.data.path) !== -1 && this.editModal.create) {
                this.$mainDialog.msgBoxOk(this.$t('routeWithSamePath'))
                return
            }

            this.routes.definitions[this.editModal.data.path] = {
                code: this.editModal.data.code
            }

            this.editModal.show = false;

            this.$emit("input", this.routes)
        },

        edit(path, route) {
            this.editModal.show = true;
            this.editModal.create = false;
            this.editModal.data = {
                path: path,
                code: route.code
            };
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        modelFields() {
            let componentUuid = this.$route.params.id
            let component = this.$store.getters.componentSettings(componentUuid)
            let fields = component.settings.fields

            let formated = {}

            if (fields !== null) {
                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })
            }

            return JSON.stringify(formated)
        }
    },
    data: function() {
        return {
            errors: [],
            routes: this.value || [],
            editModal: {
                create: false,
                show: false,
                data: {
                    path: '',
                    code: ''
                }
            },

            libs: [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                }
            ]
        }
    },

    mounted() {
        this.modelFields()
    }
}
</script>
